export const init = () => {
    const $fields = document.querySelectorAll(".c-Textfield.-js-textfield:not(.-js-upgraded)")

    for (const $field of $fields) {
        let $label = document.querySelector(`[for="${$field.id}"]`)

        if ($label) {
            $label.addEventListener("mousedown", function() {
                // Improve focus speed
                setTimeout(() => $field.focus(), 1)
            })
        }

        $field.addEventListener("focus", function() {
            if ($label) {
                // Add label focus class
                $label.classList.add("-is-focus")
                // Remove label error class
                $label.classList.remove("-is-error")
            }

            // Remove error class
            $field.classList.remove("-is-error")

            // Focus at the end of text value
            let value = $field.value
            $field.value = ""
            $field.value = value
        })

        $field.addEventListener("blur", function() {
            if ($label) {
                // Remove label focus class
                $label.classList.remove("-is-focus")
            }
        })

        $field.classList.add("-js-upgraded")
    }
}
